// test74
(74 && 0);
